export const sidebarWidth = "218px";
export const savebarHeight = "64px";
export const pageHeaderHeight = "52px";
